<template>
  <v-form
    v-if="isShown"
    class="filter white mb-5"
    @submit.prevent="submit"
  >
    <v-container fluid>
      <v-row>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('common.supplier') }}
            </label>
            <v-text-field
              v-model="localFilter.supplier"
              hide-details
              solo
            />
            <!-- <v-autocomplete
              v-model="localFilter.supplier"
              :loading="loadingSuppliers"
              :items="suppliers"
              :search-input.sync="supplierSearch"
              item-text="asdb"
              item-value="asdb"
              :readonly="!business"
              :clearable="business"
              :placeholder="$t('common.type_to_search')"
              cache-items
              hide-no-data
              hide-details
              solo
            /> -->
          </div>
        </v-col>
        <v-col
          v-if="!localFilter.consolidator"
          cols="3"
        >
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('common.plant') }}
            </label>
            <v-text-field
              v-if="business"
              v-model="localFilter.plant"
              hide-details
              solo
            />
            <v-select
              v-else-if="!filter.consolidator"
              v-model="localFilter.plant"
              :items="plants"
              item-text="plant"
              item-value="plant"
              hide-details
              solo
            />
            <v-text-field
              v-else
              v-model="localFilter.consolidator"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('views.shipment_notice_list.start_date') }}
            </label>
            <date-picker
              v-model="localFilter.startDate"
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('views.shipment_notice_list.end_date') }}
            </label>
            <date-picker
              v-model="localFilter.endDate"
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('common.number') }}
            </label>
            <v-text-field
              v-model="localFilter.number"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('views.shipment_notice_list.system_status') }}
            </label>
            <v-select
              v-model="localFilter.systemStatus"
              :items="enums.systemStatusList"
              item-text="text"
              item-value="status"
              no-data-text="Select"
              multiple
              solo
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                {{ data.index ? '' : 'Select' }}
              </template>
            </v-select>
          </div>
        </v-col>
        <v-col
          v-if="localFilter.consolidator"
          cols="3"
        >
          <div class="input-block input-block_white">
            <label class="input-block__label">
              {{ $t('views.shipment_notice_list.track_status') }}
            </label>
            <v-select
              v-model="localFilter.trackStatus"
              :items="enums.trackStatusList"
              item-text="text"
              item-value="status"
              no-data-text="Select"
              multiple
              solo
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                {{ data.index ? '' : 'Select' }}
              </template>
            </v-select>
          </div>
        </v-col>
        <v-col cols="3">
          <div class="input-block input-block_white align-center">
            <label class="input-block__label">
              {{ $t('views.shipment_notice_list.actual') }}
            </label>
            <v-checkbox
              v-model="onlyActual"
              class="mt-0"
              hide-details
            />
          </div>
        </v-col>
        <v-col
          cols="2"
          class="filter__apply"
        >
          <v-btn
            type="submit"
            color="primary"
            outlined
            large
            class="filter__apply-button"
          >
            {{ $t('common.apply') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DatePicker from '@/components/common/DatePicker.vue';
import { mongoRegexI } from '@/utils/mongo-regex';

export default {
  name: 'ShipmentNoticesFilter',

  components: {
    DatePicker,
  },

  props: {
    isShown: {
      type: Boolean,
      default: () => false,
    },

    filter: {
      type: Object,
      required: true,
    },

    plants: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      onlyActual: false,
      localFilter: {
        supplier: '',
        plant: '',
        startDate: '',
        endDate: '',
        number: '',
        systemStatus: [],
      },

      suppliers: [],
      loadingSuppliers: false,
      supplierSearch: '',

      enums: {
        // systemStatusList: ['ASN_SHIPPED', 'ASN_CANCELED']
        systemStatusList: Object.keys(this.$t('enums.asn_system_statuses')).map((status) => ({ status, text: this.$t(`enums.asn_system_statuses.${status}`) })),
        trackStatusList: ['В пути', 'Принят консолидатором', 'Отмена'].map((status) => ({ status, text: this.$t(`enums.asn_track_statuses.${status}`) })),
      },
    };
  },

  computed: {
    ...mapState(['user']),
    ...mapGetters(['business', 'consolidator']),
  },

  watch: {
    isShown(value) {
      if (value) {
        this.init();
      }
    },

    supplierSearch(value) {
      if (value && value !== this.localFilter.supplier) {
        this.getSuppliers(value);
      }
    },

    onlyActual(val) {
      this.localFilter.systemStatus = val
        ? Object.keys(this.$t('enums.asn_system_statuses')).filter((it) => it !== 'ASN_CANCELED' && it !== 'ASN_PENDING_CANCELLATION_MBS') : undefined;
    },
  },

  methods: {
    init() {
      if (!this.business) {
        this.suppliers = [{ asdb: this.user && this.user.asdb }];
      }
      this.localFilter = { ...this.filter };
    },

    async getSuppliers(str) {
      this.loadingSuppliers = true;

      const query = {
        asdb: mongoRegexI(str),
      };

      try {
        const { data = {} } = await this.$http.get('/suppliers', {
          params: { query },
        });
        this.suppliers = data.rows;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loadingSuppliers = false;
      }
    },

    submit() {
      this.$emit('applyFilter', this.localFilter);
    },
  },
};
</script>
